import React, { useEffect, useState } from "react";
import DataTable from "../../../components/DataTable/DataTable";
import { IColInfo } from "../../../components/DataTable/Interfaces";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemRevisionModel from "../../../models/ItemRevisionModel";
import DataService from "../../../services/data.service";
import FormatUtils from "../../../utils/FormatUtils";
import { TasksForMultipleItemsModel } from "../Popups/Project_popup_TasksForMultipleItems";

interface IProps {
    show: boolean
    itemsUrl?: string
    formData: TasksForMultipleItemsModel
    showSelectedOnly: boolean
    onSelectedItemChanges: (selectdItems: ItemRevisionModel[]) => void
}

const SelectedProjectItemsControl: React.FC<IProps> = ({ show, itemsUrl, formData, showSelectedOnly, onSelectedItemChanges }) => {
    const [tableData, setTableData] = useState<ItemRevisionModel[]>([])
    const [itemStatusTypes, setItemStatusTypes] = useState<string[]>()
    const { handleException } = useNotifications();
    const formatUtils = new FormatUtils()


    useEffect(() => {
        if (itemsUrl) {
            DataService
                .get<ItemRevisionModel[]>(itemsUrl)
                .then(response => {
                    let statusTypes: string[] = []
                    response.forEach(x => {
                        x.itemRevisionStatuses.forEach(y => {
                            var endDateStatusType = formatUtils.dateFromString(y.itemStatus.itemStatusType.endDate)
                            var endDateStatus = formatUtils.dateFromString(y.itemStatus.endDate)
                            if ((endDateStatusType === undefined || endDateStatusType > new Date(Date.now())) &&
                                (endDateStatus === undefined || endDateStatus > new Date(Date.now()))) {
                                if (y.isLatest && statusTypes.includes(y.itemStatus.itemStatusType.name) == false) {
                                    statusTypes.push(y.itemStatus.itemStatusType.name);
                                }
                            }
                        })
                    });
                    setItemStatusTypes(statusTypes)
                    setTableData([...response])
                    onSelectedItemChanges([])

                })
                .catch(e => handleException(e));
        }
    }, [itemsUrl])

    useEffect(() => {
        var data = tableData.filter(x => x['_checkbox_Select'] == true)
        setTableData(data)
    }, [showSelectedOnly])

    function getStatusColor(itemRevision: ItemRevisionModel, colInfo: IColInfo): string | undefined {
        if (itemRevision.itemStatus)
            return itemRevision.itemStatus.color;
    }

    function getStatus(itemRevision: ItemRevisionModel, colInfo: IColInfo): string | undefined {
        const status = colInfo.dataProp;
        let result = ''

        itemRevision.itemRevisionStatuses.forEach(y => {
            if (y.isLatest == true && y.itemStatus.itemStatusType.name == status) {
                result = y.itemStatus.name;
            }
        })
        return result;
    }

    function getBusinessPartners(itemRevision: ItemRevisionModel, colInfo: IColInfo) {
        let bp = itemRevision.item.itemBusinessPartners.filter(x => x.businessPartner.businessPartnerTypeId == formData.businessPartnerTypeId).map(x => x.businessPartner.name)
        return bp.join(', ')
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { checkboxButton: { text: "Select", icon: 'fa-check', color: 'green' }, dataProp: '-1' },
        { getCellBackgroundColor: getStatusColor, sort: false, maxWidth: 5 },
        { title: 'Item Nr', dataProp: 'item', dataType: 'item', sort: 'asc' },
        { title: 'Revision', dataProp: 'revisionNumber', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Naam', dataProp: 'item.name' },
        { title: 'Design phase', dataProp: 'designPhase' },
    ];

    if (formData.taskId == 6)
        colInfos.push({ title: 'Business-partners', dataProp: 'item.businessPartners', getCellData: getBusinessPartners })

    if (itemStatusTypes) {
        itemStatusTypes.forEach((value, index) => {
            colInfos.push({ title: value, dataProp: value, getCellData: getStatus });
        });
    }

    return <>
        {show && <DataTable
            name='dtSelectProjectItems'
            colInfos={colInfos}
            onSelectedRowsChange={onSelectedItemChanges}
            tableData={tableData}
        />}
    </>
}
export default SelectedProjectItemsControl;